import { store } from '../../../../../resources/frontend/js/store';

export const getNextQuestion = (nextQuestion, index) => {
    if(!store.state.quiz.advancedFlow) nextQuestion = 'next_question';

    if (nextQuestion === 'next_question' || !nextQuestion) {
        const question = store.state.quiz.questionsData[index];
        if (!question) return null;
        return question._info.uuid || index + 1;
    }

    const question = store.state.quiz.questionsData.find(question => question._info.uuid === nextQuestion);
    if (!question) return null;
    return question._info.uuid;
};
